import request from '@/utils/request'

// 获取模块列表
export function modules (data) {
  return request.post('/ai/modules', data)
}
// 获取字段列表
export function fields (data) {
  return request.post('/ai/fields', data)
}
// 获取字段数据列表
export function fetchFieldRows (data) {
  return request.post('/ai/field/row', data)
}
// 智能录入
export function inputSystem (data) {
  return request.post('/ai/inputSystem', data)
}
